import React from "react";
import ReactDOM from "react-dom";

import { ConnectionLabel } from "~/account/Integrations/Card";
import { aboutJiraIntegrationContent } from "~/account/Integrations/Jira/GettingStartedText";
import { ReactComponent as JiraLogo } from "~/legacy-assets/images/logos/jira.svg";
import { Modal } from "~/ui/legacyFellowIndex";

import styles from "./css/IntegrationLink.module.css";

export class PromptInstallingJiraSetupReact {
	private targetDomNode: HTMLElement;
	private readonly root: HTMLDivElement;
	private mounted: boolean;

	constructor() {
		this.root = document.createElement("div");
		this.targetDomNode = document.body;

		this.targetDomNode.appendChild(this.root);

		ReactDOM.render(<PromptInstallingJira cancel={this.abortLinking} />, this.root);
		this.mounted = true;
	}

	abortLinking = () => {
		if (!this.mounted) return;
		this.mounted = false;
		ReactDOM.unmountComponentAtNode(this.root);
		this.targetDomNode.removeChild(this.root);
	};
}

interface PromptInstallingJiraProps {
	cancel: () => void;
}

class PromptInstallingJira extends React.Component<PromptInstallingJiraProps> {
	render() {
		const isAdmin = window.INITIAL_STATE.user?.type === "ADMIN" || false;

		return (
			<Modal onClose={this.props.cancel}>
				<Modal.Header>
					<Modal.Title className={styles.center}>
						<JiraLogo className={styles.logo} /> Jira
					</Modal.Title>
					<Modal.HeaderActions onClose={this.props.cancel} className={styles.center}>
						<ConnectionLabel connected={false} />
					</Modal.HeaderActions>
				</Modal.Header>
				<Modal.Body className={styles.body}>{aboutJiraIntegrationContent}</Modal.Body>
				{isAdmin && (
					<Modal.Footer>
						<a
							className={styles.installButton}
							target="_blank"
							rel="noopener noreferrer"
							href={window.ATLASSIAN_MARKETPLACE_URL}
						>
							Install from Atlassian Marketplace
						</a>
					</Modal.Footer>
				)}
			</Modal>
		);
	}
}

export default function displayPromptInstallingJira() {
	new PromptInstallingJiraSetupReact();
}
